import styled from 'styled-components'

const TagListStyled = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

export default TagListStyled
